import "./App.scss";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "layout/Layout";
import Home from "components/pages/home/Home";
import Terms from "components/pages/term/Terms";
import Privacy from "components/pages/privacy/Privacy";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="terms" element={<Terms />} />
          <Route path="policy" element={<Privacy />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
